import React, { useState, forwardRef, useEffect, useMemo } from "react";
import PropTypes from "prop-types";

import { classNames } from "../../utils";
import { MAX_LENGTH_NUMBER } from "../../constant/common";
import { arabicToNumber, number, numberToArabic } from "@euroland/format-number";

const NumberInput = forwardRef(
  /**
   *
   * @param {{value: number|string;
   * className: string;
   * onChange: () => void;
   * formatNumber: (value: string | number) => string | number;
   * useLatinNumbers: boolean;
   * require?: boolean
   * id?: string
   * errorMessage?: string
   * }} props
   * @param {*} ref
   * @returns
   */
  (
    { value: outsideValue, onChange, className, formatNumber = value => value, useLatinNumbers = true, require, title = "", id, errorMessage = '' },
    ref
  ) => {
    const [isFormat, setIsFormat] = useState(true);
    const [value, setValue] = useState("");

    useEffect(() => {
      if (value !== outsideValue) {
        setValue(
          typeof outsideValue === "number" || typeof outsideValue === "string"
            ? !useLatinNumbers && !!outsideValue
              ? formatNumber(String(outsideValue))
              : outsideValue
            : ""
        );
      }
    }, [outsideValue]);

    const handleChange = e => {
      const inputValue = !useLatinNumbers ? arabicToNumber(e.target.value) : e.target.value;
      if (
        Number.isNaN(Number(inputValue)) ||
        inputValue.match(/\.\d*$/)?.index >= MAX_LENGTH_NUMBER ||
        (!/\.\d*$/.test(inputValue) && inputValue.length >= MAX_LENGTH_NUMBER)
      ) {
        return;
      }
      if (!useLatinNumbers && !!inputValue) {
        const valueString = /^.*\.$/.test(inputValue) ? e.target.value : numberToArabic(inputValue);
        setValue(valueString);
        onChange(valueString);
        return;
      }
      setValue(inputValue);
      onChange(inputValue);
    };
    const handleFocus = () => {
      setIsFormat(false);
    };
    const handleBlur = () => {
      setIsFormat(true);
    };

    const convertValue = useMemo(() => {
      if (isFormat && !useLatinNumbers && value) {
        const numberValue = number(arabicToNumber(value), undefined, { useLatinNumbers: true });
        return formatNumber(numberValue);
      }
      if (!useLatinNumbers && value === 0) {
        return formatNumber(value);
      }
      if (isFormat && (value || typeof value === "number")) {
        return formatNumber(Number(value));
      }
      return value;
    }, [value, isFormat]);
    return (
      <div className="number-input__wrapper">
        <input
          ref={ref}
          className={classNames("number-input", className)}
          value={convertValue}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          type="text"
          title={title}
          id={id}
          autoComplete="off"
          {...(errorMessage ? {'aria-describedby': `input-error-${id}`} : {})}
          {...(require ? {
            require: 'true',
            'aria-required': 'true'
          } : {})}
        />
        {errorMessage ? <span className="number-input__error-message" id={`input-error-${id}`}>{errorMessage}</span> : null}
      </div>
    );
  }
);

NumberInput.propTypes = {
  // value: PropTypes.number | PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  formatNumber: PropTypes.func,
};

export default NumberInput;
